import { menu } from '@tools/Menu.svelte';
import { quartInOut } from 'svelte/easing';
import type { TransitionConfig } from 'svelte/transition';

export class contentTransitionsData {
	public static scroll = 0;
}

const outDuration = 600;
const menuDuration = 600;
const inDuration = 400;
const easing = quartInOut;

export const contentSlide = (
	node: HTMLElement,
	_: undefined,
	options: { direction: 'in' | 'out' | 'both' }
): TransitionConfig => {
	const existingTransform = getComputedStyle(node).transform.replace('none', '');

	let duration = outDuration;
	let timeToWait = 1;

	if (menu.current && options.direction === 'out') {
		duration = 0;
	}

	if (options.direction === 'in') {
		duration += inDuration;
		timeToWait = (duration - inDuration) * 1.333;

		if (menu.current) {
			duration += menuDuration;
			timeToWait = duration - inDuration;
		}
	}
	const waitingMultiplier = duration / timeToWait;

	return {
		duration,
		easing,
		css: (_, u) => {
			let timed = u;
			if (options.direction === 'in') {
				timed = Math.min(1, u * waitingMultiplier);
			}
			const t = 1 - timed;
			return `transform: ${existingTransform} translateY(${40 * timed}px); opacity: ${1 * t};`;
		}
	};
};

export const contentZoom = (
	node: HTMLElement,
	_: undefined,
	options: { direction: 'in' | 'out' | 'both' }
): TransitionConfig => {
	const existingTransform = getComputedStyle(node).transform.replace('none', '');

	let duration = outDuration;
	let timeToWait = 1;

	if (menu.current && options.direction === 'out') {
		duration = 0;
	}

	if (options.direction === 'in') {
		duration += inDuration;
		timeToWait = (duration - inDuration) * 1.333;

		if (menu.current) {
			duration += menuDuration;
			timeToWait = duration - inDuration;
		}
	}

	const waitingMultiplier = duration / timeToWait;

	return {
		duration,
		easing,
		css: (_, u) => {
			let timed = u;
			if (options.direction === 'in') {
				timed = Math.min(1, u * waitingMultiplier);
			}
			// let t = 1 - timed;
			return `transform: ${existingTransform} scale(${1 + 0.1 * timed});`;
		}
	};
};

export const contentFade = (
	_: HTMLElement,
	__: undefined,
	options: { direction: 'in' | 'out' | 'both' }
): TransitionConfig => {
	let duration = outDuration;

	if (menu.current) {
		duration = 0;
	}

	return {
		duration,
		easing,
		css: (t, _) => {
			if (options.direction === 'out') {
				return `position: fixed; top: calc(var(--nav-height) - ${contentTransitionsData.scroll}px);`;
			} else {
				return `opacity: ${1 * t}; z-index: 2;`;
			}
		}
	};
};
